import { Children } from "react";
import Link from "next/link";

import { CardNews } from "@aprosoja/containers";
import { colors } from "@aprosoja/styles/tokens";
import { CategoryType } from "@aprosoja/types";
import { Button, Text } from "@aprosoja/ui";

type CardNewsByCategoryProps = {
  data: CategoryType;
};

const CardNewsByCategory = ({ data }: CardNewsByCategoryProps) => {
  const activeNews = data?.news.filter((item) => item.status === true);
  return (
    <div className="flex flex-col gap-size-x6 w-full">
      <div className="flex justify-between gap-size-x4">
        <Text type="headingS" color={data.color as keyof typeof colors}>
          {data?.name}
        </Text>
        <Link href={`/categoria/${data.slug}`} passHref>
          <Button variant="text">Ver mais</Button>
        </Link>
      </div>
      {activeNews &&
        Children.toArray(
          activeNews
            .slice(0, 2)
            .map((item, index) => (
              <CardNews
                data={item}
                orientation="vertical"
                hasImage={index === 0}
              />
            ))
        )}
    </div>
  );
};

export default CardNewsByCategory;
